import Handlebars, { HelperOptions } from 'handlebars';
import { capitalize } from 'core/common/utils/capitalize';
import { formatPrice } from 'core/common/utils/formatPrice';
import { TemplateEngine } from 'core/funnel/interfaces';
import { t } from 'core/localization/utils/getCurrentLanguage';
import { Offer } from 'core/offers/entities/Offer';
import { getPriceBeforeDiscount } from 'core/offers/utils/getPriceBeforeDiscount';

export class HandlebarsTemplateEngine implements TemplateEngine {
  private handlebarsInstance = Handlebars;

  constructor() {
    this.registerHelpers();
  }

  compile(value: string) {
    return this.handlebarsInstance.compile(value, { noEscape: true });
  }

  private registerHelpers() {
    this.handlebarsInstance.registerHelper('translate', function (...args) {
      const value = args.slice(0, args.length - 1).join('.');

      return t(value);
    });

    this.handlebarsInstance.registerHelper('capitalize', (value: string) => {
      return capitalize(value);
    });

    this.handlebarsInstance.registerHelper(
      'priceBeforeDiscount',
      (offer: Offer | undefined, discountPercent: unknown, options: HelperOptions) => {
        return this.renderPriceBeforeDiscount(offer, Number(discountPercent), options.hash.field);
      },
    );
  }

  private renderPriceBeforeDiscount(
    offer: Offer | undefined,
    discountPercent: number,
    field: unknown,
  ) {
    const price = this.getOfferPrice(offer, field);

    if (!offer || !price) {
      return '';
    }

    const priceBeforeDiscount = getPriceBeforeDiscount(price, discountPercent, offer.minorUnits);

    if (!priceBeforeDiscount) {
      return '';
    }

    return formatPrice(priceBeforeDiscount);
  }

  private getOfferPrice(offer: Offer | undefined, field: unknown) {
    if (!offer) {
      return null;
    }

    const prices: Record<string, number> = {
      price: offer.price,
      trialPrice: offer.trialPrice,
    };

    const fieldName = typeof field === 'string' ? field : 'price';
    const price = prices[fieldName];

    return price > 0 ? price : null;
  }
}
